module.exports = __webpack_public_path__ + "static/media/rfbased4.f9af001b.jpg";